const invalidEmail = 'Sähköpostiosoite virheellinen';
const emailLabel = 'Sähköposti';

const fi: LocaleType = {
  header: 'this is a header',
  subtitle: (...args: string[]) => `${args[0]} is ${args[1]}`,
  cancel: 'Peru',
  login_button: 'Kirjaudu sisään',
  signout: 'Kirjaudu ulos',
  loading: 'Odota hetkinen',
  read_more: 'Lue lisää',
  general: {
    countryNameFI: 'Suomi',
    countryNameSE: 'Ruotsi',
    countryOfEntryIllativeFI: 'Suomeen',
    countryOfEntryIllativeSE: 'Ruotsiin',
  },
  auth: {
    successAuth: 'Todennus onnistui. Uudelleenohjaus kotisivulle',
    processing: 'Käsitellään todennusta',
    invalidAuth: 'Virheellinen istunto käyttäjälle.',
  },
  errors: {
    default: 'Pyyntöä ei voi toimittaa.',
    duplicate: 'Tiedot ovat jo järjestelmässä.',
    invalidEmail: invalidEmail,
    pageNotFound: 'Sivua ei löydy',
  },
  cookie: {
    message:
      'Tämä sivusto käyttää evästeitä antaakseen sinulle erinomaisen käyttökokemuksen. Jatkamalla tämän verkkosivuston käyttöä hyväksyt evästeiden käytön kanssamme.',
    policy: 'Evästekäytännöt',
    accept: 'Hyväksy',
  },
  landing_page: {
    header: {
      user: {
        hey: (...args: string[]) => `Hei ${args[0]}, `,
        bookings: 'katso omat varauksesi tästä',
        check_bookings: 'Katso omat varaukset',
        has_reservation: 'Varaus jo olemassa? ',
      },
      menus: {
        home: 'Etusivu',
        parks: 'Parkit',
        bestpoint: 'BestPoint-huoltopiste',
        why_bestpark: 'Miksi BestPark?',
        our_story: 'Tarinamme',
        info: 'Info',
        for_host: 'Isännille',
        the_cities: 'Kaupungeille',
        contact_us: 'Ota yhteyttä',
        login: 'Kirjaudu sisään',
      },
      all_parks: 'Kaikki matkaparkit',
      buy_tickets: 'Osta lippu',
      buy: 'Osta',
      for_host: 'Isännille',
      demonstration: 'Esittely',
      the_cities: 'Kaupungeille',
      make_reservation: 'Tee varaus',
      the_press: 'Lehdistölle',
    },
    footer: {
      follow: 'Seuraa meitä',
      contact: 'Yhteystiedot',
      quick_links: 'Nopeat linkit',
      traveling: 'Matkustan kanssasi',
      other_links: 'Muut linkit',
      privacy_statement: 'Tietosuojatiedot',
      terms_of_delivery: 'Toimitusehdot',
      see_map: 'Katso kartalla',
      travel: 'Mukana matkassa',
      privacy: 'Tietosuojaehdot',
      media: 'Lehdistölle',
    },
    hero: {
      title: 'Paras parkki pysähtyä!',
      text: 'Avaamme kuusi uutta parkkia kesäksi 2020.',
      view_parks: 'Katso matkaparkkeja',
    },
  },
  park_info: {
    header: 'Valitse saapumis- ja lähtemispäivä kalenterista',
    amenities: (...args: string[]) =>
      `${args[0]} paikat ja ${args[1]} mukavuudet:`,
    faq: 'Usein kysytyt kysymykset',
    extras: {
      area: 'Alue',
      forWhom: 'Kenelle',
      thingsToDo: 'Näkemistä ja tekemistä',
    },
    intro: 'Tarinamme',
  },
  reservation: {
    noReservation: 'Ei varauksia',
    continue: 'Jatka',
    previous: 'Edellinen',
    loading: 'Odota hetkinen',
    slots: {
      header: 'Montako yötä aiot parkkeerata?',
      arrival: (...args: string[]) => `Saapumispäivä ${args[0]}.`,
      comment: (...args: string[]) =>
        `Seuraava viikonloppu on loppuunmyyty, joten enimmäismäärä öitä per oleskelu voi olla ${args[0]}.`,
      choose: 'Valitse paikka',
      chooseTitle: 'Valitse paikka',
      unavailable: 'Ei saatavilla',
      regularSlots: 'Peruspaikat',
      price: (...args: string[]) => `(hinta ${args[0]} ${args[1]}/yö)`,
      addPrice: (...args: string[]) => `(lisähinta +${args[0]} ${args[1]}/yö)`,
      slotError: (...args: string[]) =>
        `Slot ${args[0]} is no longer available. Select a new one.`,
    },
    coupon: {
      validateCoupon: 'Vahvista',
      couponCode: 'Kuponkikoodi',
      couponInvalid: 'Virheellinen kuponki',
      couponApplied: 'Kuponki lisätty',
      couponDiscount: 'Kuponkialennus',
      couponExpired: 'Tämä kuponki on jo vanhentunut',
      invalidPark: 'Tämä kuponki ei kelpaa valitulle Parkille',
      limitExceeded: 'Tämän kupongin käyttömäärä on täynnä',
      userLimitExceeded: 'Tämä kuponki on jo käytetty',
      shortNights: 'Tämä kuponki ei kelpaa valituille yömäärälle',
      exceedingNights: 'Tämä kuponki ei kelpaa valituille yömäärälle',
    },
    registration: {
      header: 'Yhteystietosi',
      subheader: 'Onko sinulla jo oma BestPark tili?',
      login: 'Kirjaudu sisään tästä',
      loginNote:
        'Kirjaudu sisään tarkistaaksesi varaustiedot. Kirjaudu sisään tästä',
      firstName: 'Etunimi',
      lastName: 'Sukunimi',
      phone: 'Puhelin',
      phoneInfo:
        'Puhelinnumero (kans. välisessä muodossa, esim. +358401234567)',
      email: emailLabel,
      street: 'Katuosoite',
      postalCode: 'Postinumero',
      town: 'Postitoimipaikka',
      country: 'Asuinmaa',
      license: 'Vetoauton rekisterikilpi',
      promos:
        'Tilaa uutiskirje ja kuule ensimmäisten joukossa tuoreimmat BestPark -uutiset.',
      errors: {
        fillRequired: 'Täytä korostetut kentät',
        email: 'Sähköpostiosoite virheellinen',
        phone:
          'Numeron pitää olla kansainvälisessä muodossa, esim. +358401234567',
        emailExist: 'Sähköpostiosoite on jo rekisteröity.',
        fieldRequired: 'Pakollinen kenttä',
      },
      clickHereToReserve: 'Aloita varauksesi tästä',
    },
    payment: {
      header: 'Maksu',
      subheader: 'Viimeistele varaus valitsemalla maksutapa.',
      night: (...args: string[]) =>
        `${args[0]} ${
          parseInt(args[0]) > 1 ? 'vuorokautta' : 'vuorokausi'
        } parkissa`,
      total: 'Yhteensä',
      totalInCurrency: (...args: string[]) => `Yhteensä (${args[0]})`,
      currencyConversionNote: (...args: string[]) =>
        `Valuuttamuunnos ${args[0]}-${args[1]} maksua varten`,
      cardPay: 'Maksa pankki- tai luottokortilla',
      mobilePay: 'Maksa mobiilimaksulla',
      collectorBankPay: 'Maksa laskulla tai erissä',
      invoicePayment: 'Maksa laskulla',
      invoiceNote: (...args: string[]) =>
        `laskutuslisä ${args[0]} ${Number(args[0]) > 1 ? 'euroa' : 'euro'}`,
      surcharge: 'Lisämaksu',
      onlineBankPay: 'Maksa verkkopankissa',
      coupon: 'Onko sinulla kampanjakoodi?',
      terms1: 'Olen lukenut',
      terms2: 'tilaus- ja toimitusehdot',
      terms3: 'Perustamme helppokäyttöisen asiakastilin BestPark ostoksillesi',
      pay: (...args: string[]) => `Maksa ${args[0]} nyt`,
      processingPayment: 'Käsitellään varausmaksua',
      paymentProcessed:
        'Maksusi on käsitelty ja antamaasi sähköpostiosoitteeseen on lähetetty varausvahvistusviesti. Mikäli varausvahvistusta ei ole saapunut 15 minuutin kuluessa, tarkistathan ettei viesti ole mennyt roskapostikansioon.',
      paymentError:
        'Jokin meni vikaan! Tarkistamme tilanteen. Voit tehdä tukipyynnön.',
      orderNumber: 'Order number: ',
      failed: 'Maksutapahtuma keskeytynyt',
    },
    card: {
      goToReservation: 'Mene varaukseeni',
      days: (...args: string[]) =>
        `${args[0]} ${parseInt(args[0]) > 1 ? 'vuorokautta' : 'vuorokausi'}`,
    },
    profile: {
      header: 'Varaukseni',
    },
    guestInformation: {
      header: 'Matkustajailmoitus',
      firstName: 'Etunimi',
      lastName: 'Sukunimi',
      address: 'Osoite',
      dateOfBirth: 'Syntymäaika',
      nationality: 'Kansalaisuus',
      passportNumber: 'Passin/henkilökortin numero',
      dateOfArrival: 'Saapumispäivä',
      countryOfEntry: (...args: string[]) =>
        `Maa, josta matkustaja saapuu ${args[0]}`,
      addChildButton: 'Lisää perheenjäsen',
      addPassenger: 'Lisää toinen matkustaja',
      passengerInformation: 'Matkustajan henkilötiedot',
      childSpouseInfo: 'Perheenjäsenen henkilötiedot',
      passportInfo: 'Pohjoismaiden kansalaiset eivät täytä',
      companionHeader:
        'Matkustajan mukana olevan puolison ja alaikäisten lasten henkilötiedot',
      subHeader:
        'Väärien henkilötietojen antamisesta on säädetty rangaistus rikoslaissa.',
      delete: 'poista',
    },
    ancillary: {
      header: 'Lisäpalvelut',
      skip: 'Siirry seuraavaan',
      subheader1: 'Viivy matkalla, vaikka Parkissa',
      subheader2:
        'Sähköpotkulautoja ja pyöriä vuokrattavana kaikissa Parkeissa',
      subheader3:
        'Paikkoja saatavava rajoitettu määrä, joten varaa omasi ajoissa!',
      soldOut: 'Valitettavasti loppuunmyyty valitseminasi päivinä',
      soldOutDay: (...args: string[]) =>
        `Kaikki ${args[0]} on varattu tälle päivälle`,
      price: (...args: string[]) => `${args[0]}€ vuorokausi`,
      reservation: 'Valitse määrä ja päivät:',
      max: (...args: string[]) =>
        `Vain ${args[0]} vapaana valitsemallesi päivälle`,
      total: 'Yhteensä:',
      totalService: (...args: string[]) =>
        `${args[0]} ${args[1]} on ${args[2]} ${
          parseInt(args[2]) > 1 ? 'Päivät' : 'Päivä'
        }`,
      firstDayNote:
        'Varauksesi alkaa klo 13 ja on voimassa seuraavaan päivään klo 12 asti.',
      dayNote: 'Reservation starts at 12:00 and ends 12:00 next day',
      lastDayNote: 'Reservation starts at 12:00 and ends 12:00 next day',
    },
    details: {
      checkIn: 'Sisään&shy;kirjautuminen',
      checkOut: 'Ulos&shy;kirjautuminen',
      info: (...args: string[]) => `
      Sisäänkirjautumisaika alkaa kello ${args[0]} joka päivä ja uloskirjautumisaika on klo ${args[1]} mennessä`,
      addOns: {
        earlyCheckIn: {
          info: ' Myöhäinen sisäänkirjautuminen klo 13 asti',
          button: (...args: string[]) => `Lisää kohteelle ${args[0]}${args[1]}`,
        },
        lateCheckOut: {
          info: 'Myöhäinen uloskirjautuminen klo 15:00',
          button: (...args: string[]) => `Lisää kohteelle ${args[0]}${args[1]}`,
        },
      },
      parking: {
        textSlot: 'Parkkisi',
        title: (...args: string[]) => `${args[0]}`,
        slot: (...args: string[]) =>
          `Sinulle on varattu  ${args[0]} numero ${args[1]}.`,
      },
      map: {
        button: 'Navigoi Parkkiin',
      },
      general: {
        title: 'Portti avautuu',
        text:
          'Kun saavut Parkkiin, voit avata portin tällä henkilökohtaisella koodilla:',
        linkInfo: (...args: string[]) => `Näytä tiedot ${args[0]} BestParkista`,
        linkModify: 'Haluatko muokata tai peruuttaa tämän varauksen?',
        linkDownload: 'Lataa kuitti',
        add: 'Lisää',
      },
      services: {
        title: (...args: string[]) => `Sinun ${args[0]}`,
        text: (...args: string[]) =>
          `Tähän tulee ohjeet, mistä voit noutaa varaamasi ${args[0]}.`,
      },
      extendReservation: 'Jatka varaustasi',
      cancelReservation: 'Peruuta varaus',
      cancelledReservation: 'Peruttu varaus',
    },
    confirmation: {
      confirmed: 'Varauksesi on vahvistettu',
      pending: 'Varaus on tällä hetkellä odottamassa.',
      confirmed_message: (...args: string[]) =>
        `Kiitos varauksestasi, nähdään ${args[0]}`,
    },
    errors: {
      cancel: 'Voit peruuttaa varauksen 7 päivää ennen saapumistasi',
    },
    success: {
      cancel: 'Varaus on peruttu',
    },
    receipt: {
      invoice: (...args: string[]) => `Kuitti #${args[0]}`,
      header: (...args: string[]) =>
        `Kiitos varauksesta ${args[0]}, se on maksettu kokonaisuudessaan ${args[1]} ${args[2]}`,
      details: {
        paymentDate: 'Maksupäivä',
        contactEmail: 'Sähköpostiyhteys',
        chargedTo: 'Veloitetaan',
        chargedFree: 'Veloitukseton',
        forReservation: 'Varaukselle',
      },
      breakdown: {
        park: 'Parkki',
        couponUsed: 'Kuponkikoodi',
        couponDiscount: (...args: string[]) => `Alennus ${args[0]} ${args[1]}`,
        serviceEntry: 'Huoltokäynti',
        subtotal: 'Välisumma',
        grandTotal: 'Yhteensä (Sis. ALV)',
        taxNotes: 'ALV',
        vat: (...args: string[]) => `${args[0]} ${args[1] ?? 10}%`,
      },
      businessId: 'Y-tunnus',
    },
    extension: {
      full_title: 'Varauksen jatkaminen ei ole mahdollista',
      full_description: (...args: string[]) =>
        `Valitettavasti varaustasi ei voi enää jatkaa, koska pysäköintipaikka ${args[0]} ${args[1]} ei ole enää saatavilla.`,
      full_description2: 'Voit varata toisen parkkipaikan varaussivultamme',
      book_reservation: 'Tee uusi varaus',
    },
  },
  promotions: {
    general: {
      read_more: 'Lue lisää',
    },
    hotline: {
      title: 'Puhelin­päivystys 24/7',
      text: 'Asiakaspalvelu on aina tavoitettavissa',
      footer: 'Puhelun hinta 0300-numeroon 8,35 snt/puh + 16,69 snt/min ',
    },
    infos: {
      title: 'Vaikuta!',
      text: 'Vinkkaa parhaat paikat ja osallistu lahjakorttien arvontaan.',
      buttonText: 'Kyselyyn',
    },
  },
  login: {
    header: 'Kirjaudu tilillesi',
    subheader: 'Ei vielä tiliä? ',
    registrationLink: 'Rekisteröidy tästä',
    forgetPasswordLink: 'Unohditko salasanan?',
    email: emailLabel,
    password: 'Salasana',
    continue: 'Jatka',
    authContent: 'Anna todennuskoodi joka on lähetetty puhelimeen ',
    errors: {
      fillRequired: 'Täytä korostetut kentät',
      email: invalidEmail,
      sessionInvalidated: 'Istunto vanhentunut, kirjaudu sisään uudelleen',
      invalidCode: 'Kelpaamaton koodi',
    },
  },
  mail: {
    header: 'Tarkista puhelimesi',
    open: 'Avaa Mail-App',
    content: (...args: string[]) =>
      `Lähetimme kirjautumislinkin osoitteeseen ${args[0]}, josta pääset kirjautumaan sisään.`,
  },
  registration: {
    header: 'Rekisteröi tili',
    subheader: 'Onko sinulla jo oma BestPark tili? ',
    registerButton: 'Rekisteröi',
    success: {
      header: 'Rekisteröitymisesi onnistui.',
      content: 'Voit nyt kirjautua tilillesi.',
    },
  },
  profileEdit: {
    header: 'Muokkaa käyttäjätiliä',
    subheader: 'Päivitä käyttäjätilisi tiedot',
    editButton: 'Muokkaa käyttäjätietoja',
    success: {
      header: 'Asiakastilin tiedot päivitetty',
      content: 'Asiakastilini',
    },
  },
  book_category: {
    unavailable_title: (...args: string[]) =>
      `${args[0]} paikkaa ei saatavilla.`,
    unavailable_description: 'Haluatko varata matkailuajoneuvopaikan.',
    book_reservation: 'Varaa matkailuajoneuvopaikka',
  },
  calendar: {
    general: {
      start_reservation: 'Aloita varaus',
      select_check_in: 'Valitse sisäänkirjautumispäivä',
      select_check_out:
        'Valitse uloskirjautumispäivä ja klikkaa aloita varaus.',
      select_extended_check_out: 'Valitse uloskirjautumispäivä',
      extension_title: 'Jatka varaustasi',
      extension_description: 'Voit jatkaa samaa varausta enintään 7 lisäyöllä',
      to_pay: 'Maksamaan',
      summary_extension: (...args: string[]) =>
        `Varauksen jatkaminen ${args[0]} yöllä yhteensä ${args[1]} ${args[2]}. Uusi uloskirjautuminen ${args[3]} klo 12 mennessä.`,
      summary: (...args: string[]) =>
        `Varaus alkaen ${args[0]} jatkuen ${args[1]} asti.\nSisäänkirjautuminen alkaen klo ${args[2]}, uloskirjautuminen viimeistään klo ${args[3]}. Hinta yhteensä: ${args[4]} ${args[5]}.`,
      cancellation_policy:
        'Ilmainen peruutus 2 vrk ennen saapumista. Palautus 50% kun peruutus tehdään ennen klo 13:00 saapumispäivänä.',
    },
    months: {
      january: 'tammikuu',
      february: 'helmikuu',
      march: 'maaliskuu',
      april: 'huhtikuu',
      may: 'toukokuu',
      june: 'kesäkuu',
      july: 'heinäkuu',
      august: 'elokuu',
      september: 'syyskuu',
      october: 'lokakuu',
      november: 'marraskuu',
      december: 'joulukuu',
    },
    in_months: {
      january: 'tammikuussa',
      february: 'helmikuussa',
      march: 'maaliskuussa',
      april: 'huhtikuussa',
      may: 'toukokuussa',
      june: 'kesäkuussa',
      july: 'heinäkuussa',
      august: 'elokuussa',
      september: 'syyskuussa',
      october: 'lokakuussa',
      november: 'marraskuussa',
      december: 'joulukuussa',
    },
    weeks: {
      monday: 'Ma',
      tuesday: 'Ti',
      wednesday: 'Ke',
      thursday: 'To',
      friday: 'Pe',
      saturday: 'La',
      sunday: 'Su',
    },
  },
  parks: {
    from: 'Alkaen',
    check_advance: 'Tutustu ennakkoon',
    promotion: (...args: string[]) =>
      `Meillä on ${args[0]} nykyaikaista matkaparkkia kesäksi ${args[1]}`,
    per_night: 'vuorokausi',
    listTitle: (...args: string[]) => `Kesän ${args[0]} parkit:`,
  },
  newsletter: {
    title: 'Tilaa uutiskirje',
    subscribe: 'Tilaa',
    subscribeMsg:
      'Älä aja parkkisi ohi! Tilaa uutiskirje ja kuulet ensimmäisten joukossa tuoreimmat BestPark-uutiset.',
    notifications: {
      subscribeSuccess: 'Kiitos mielenkiinnosta, kuulet meistä pian!',
      subscribeError: 'Virhe pyyntösi käsittelyssä. Ole hyvä, yritä uudelleen.',
    },
  },
  mediaPage: {
    visualisation: 'Visualisointikuvat',
    stock: 'Kuvituskuvat',
    parkImages: 'Esittelykuvat',
  },
  contactUs: {
    billingHeader: 'Laskutustiedot',
    businessId: 'Y-tunnus',
    paymentTerm: 'Maksuehto',
    paymentTermValue: (term: string) => `${term}pv`,
    invoiceAddress: 'Verkkolaskuosoite',
    brokerAddress: 'Välittäjän osoite',
    send: 'Lähetä',
  },
  articles: {
    title: 'Karavaanielämää',
  },
  formLabels: {
    message: 'Viestisi',
    name: 'Nimi',
    email: emailLabel,
    place: 'Paikkakunta',
    authCode: 'Todennuskoodi',
  },
  serviceEntry: {
    card: {
      header: 'Huollon tarpeessa?',
      subheader1:
        'Varaa huoltokäynti, joka toimii matkasi varikkokäyntinä. Saat koodin joka on voimassa 60 minuuttia saapumisestasi parkkiin.',
      subheader2: 'Huollon voit tehdä 07-22 välisenä aikana.',
      cta: (...args: string[]) => `Varaa huoltokäynti ${args[0]} ${args[1]}`,
    },
    selectDate: {
      header: 'Valitse huoltokäynnin päivä',
      reminder:
        'Pääsykoodi on voimassa 60 minuuttia aktivoinnista parkin portilla.',
      cta: 'Jatka yhteystietoihin',
    },
    confirmation: {
      paymentProcessed:
        'Maksusi on käsitelty ja antamaasi sähköpostiosoitteeseen on lähetetty varausvahvistusviesti. Mikäli varausvahvistusta ei ole saapunut 15 minuutin kuluessa, tarkistathan ettei viesti ole mennyt roskapostikansioon.',
    },
    summary: {
      buttonText: 'Katso huoltokäynti',
      dayInPark: 'Huoltokäynti',
    },
    details: {
      date: 'Huoltokäynnin ajankohta',
      listHeader: 'Huoltokäynnit',
    },
  },
  book: {
    header: (...args: string[]) =>
      `Varaa paikka kohteeseen\n ${args[0]} BestPark`,
    headerCategory: (...args: string[]) =>
      `Varaa ${args[0]} kohteeseen\n ${args[1]} BestPark`,
    maintenanceHeader: (...args: string[]) =>
      `Varaa huoltokäynti kohteeseen\n ${args[0]} BestPark`,
  },
};

export default fi;
